// asyncronous, gaan we gebruiken om naar de api te gaan

import {
  api,
} from '@/utils';

import LEASING_COMPANY_ACTION_TYPES from './leasing-company.action-types';
import LEASING_COMPANY_MUTATION_TYPES from './leasing-company.mutation-types';

const LEASING_COMPANY_ACTIONS = {
  [LEASING_COMPANY_ACTION_TYPES.FETCH_DATA_LEASING_COMPANIES]({
    commit,
  }) {
    return new Promise((resolve, reject) => {
      api.get('leasingcompany/getall')
        .then((response) => {
          if (response.data != null) {
            commit(LEASING_COMPANY_MUTATION_TYPES.APPEND_LEASING_COMPANIES, response.data);
          }

          resolve();
        })
        .catch((error) => {
          commit(LEASING_COMPANY_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
};

export default LEASING_COMPANY_ACTIONS;
